import type { WishlistSummaryViewModel } from '@nexus/customer/wishlists/model';
import type { WishlistOverviewRowView } from '../types/wishlist-overview-row-view.interface';

export function mapWishlistSummaryRow(summary: WishlistSummaryViewModel): WishlistOverviewRowView {
  const showReservations = summary.reservedCount !== null && summary.pendingCount !== null &&
    !(summary.surpriseMode && summary.viewerRole === 'beneficiary');
  const beneficiaryLabel = `Dla: ${summary.beneficiaryDisplayName}`;
  const giftsLabel = `${summary.itemsCount} pomysłów`;
  const progressLabel: string = showReservations ? `${summary.reservedCount} z ${summary.itemsCount} zarezerwowanych` : '';
  const pendingLabel: string | null = showReservations && (summary.pendingCount ?? 0) > 0 ? `${summary.pendingCount} oczekuje na email` : null;
  const statusLabel: string | null = summary.status === 'archived' ? 'Archiwalna' : null;
  return {
    id: summary.id, title: summary.title, description: summary.description ?? '',
    ownerLabel: null, beneficiaryLabel, giftsLabel,
    metaLabel: '', activityLabel: '', statusLabel,
    accessibleLabel: [summary.title, beneficiaryLabel, giftsLabel, progressLabel, pendingLabel, statusLabel, summary.visibility === 'private' ? 'Prywatna lista' : null].filter(Boolean).join('. '),
    isPrivate: summary.visibility === 'private', itemsCount: summary.itemsCount,
    reservedCount: showReservations ? summary.reservedCount ?? 0 : 0,
    pendingCount: showReservations ? summary.pendingCount ?? 0 : 0,
    progressLabel, pendingLabel, showReservations,
  };
}
